<template>
  <div class="carrersContent">
    <div class="head">
      <h1>
        {{$t("CarrersContent")}}
      </h1>
    </div>
    <!-- 招聘内容 -->
    <div class="content">
      <ul>
        <li
          v-for="(item, index) in JobContent"
          :key="index"
        >
          <!-- 职位 -->
          <div class="job_title">
            {{item.JobTitle}}
          </div>
          <!-- 职位描述 -->
          <div class="job_des">
            <h2>
              {{item.JobDes.JobDesTitle}}
            </h2>
            <ul>
              <li
                v-for="(item, index) in item.JobDes.JobDesList"
                :key="index"
              >
                {{item}}
              </li>
            </ul>
          </div>
          <!-- 职位要求 -->
          <div class="job_ask">
            <h2>
              {{item.JobAsk.JobAskTitle}}
            </h2>
            <ul>
              <li
                v-for="(item, index) in item.JobAsk.JobAskList"
                :key="index"
              >
                {{item}}
              </li>
            </ul>
          </div>
        </li>
      </ul>
      <a
        href="mailto:hr@ceasia.hk"
        target="_blank"
      >
        {{$t("JobUsBtn")}}
      </a>
    </div>

  </div>
</template>

<script>
export default {
  computed: {
    JobContent() {
      return this.$t('JobContent')
    },
  },
}
</script>

<style lang="sass">
@import "./style/carrersContent"
</style>



// WEBPACK FOOTER //
// src/components/careers/careersContent.vue